var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hm-jielong"},[_c('div',{staticClass:"hm-jielong"},[_c('img',{staticClass:"img",attrs:{"src":_vm.image}})])])}
var staticRenderFns = []

export { render, staticRenderFns }